export const addAddressSelector = ({ address }) => address;
